import type * as React from "react"
import { NavLink } from "react-router-dom"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

/**
 * The foot of the rail — `dashboard-01`'s `NavSecondary`.
 *
 * ONE CHANGE: `<a href>` BECOMES `<NavLink to>`. The block uses a plain anchor,
 * which in a client-side router triggers a FULL PAGE RELOAD — the bundle is
 * re-parsed, every query cache is thrown away, and the sidebar's open/closed
 * state resets. It looks like navigation and costs a cold start. On a workshop
 * connection that is the difference between instant and several seconds.
 *
 * The active state comes from `NavLink`'s own `isActive`, so it cannot drift
 * from the route the way a hand-written path comparison would.
 */
export function NavSecondary({
  items,
  ...props
}: {
  items: {
    title: string
    url: string
    icon: React.ReactNode
  }[]
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.url}>
              <NavLink to={item.url}>
                {({ isActive }) => (
                  <SidebarMenuButton isActive={isActive} tooltip={item.title}>
                    {item.icon}
                    <span>{item.title}</span>
                  </SidebarMenuButton>
                )}
              </NavLink>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
